const yogaInstructorService = {
  title: "Yoga Instructor",
  icon: "🧘",
  rateCardKey: "yoga-instructor",
  shortDescription:
    "Home yoga sessions, beginner guidance, flexibility routines, and recurring plans.",
  longDescription:
    "Book yoga sessions for beginners, home wellness routines, flexibility work, breathing practice, and recurring guided instruction.",
  consultationNote:
    "Therapeutic yoga, injury-specific routines, or advanced training should begin with consultation.",
  responsePromise:
    "Assignment depends on slot timing, session type, and instructor fit.",
  warrantyPolicy:
    "Wellness outcomes depend on user consistency, body condition, and session continuity.",
  subServices: [
    {
      id: "yoga-single-session",
      title: "Single Yoga Session",
      icon: "🧘",
      group: "Sessions",
      description:
        "One guided yoga session at home for basic wellness, flexibility, or beginner practice.",
      basePrice: 499,
      priceType: "fixed",
      duration: "60 mins",
      warranty: "Session completion only",
      unit: "session",
    },
    {
      id: "yoga-weekly-plan",
      title: "Weekly Yoga Plan",
      icon: "📆",
      group: "Recurring",
      description:
        "Recurring weekly instructor-led yoga sessions depending on frequency.",
      basePrice: 1499,
      priceType: "starts_at",
      duration: "Weekly plan",
      warranty: "Attendance/support policy",
      unit: "week",
    },
    {
      id: "yoga-monthly-plan",
      title: "Monthly Yoga Plan",
      icon: "🌿",
      group: "Recurring",
      description:
        "Structured home yoga plan for longer-term routine building.",
      basePrice: 3999,
      priceType: "starts_at",
      duration: "Monthly plan",
      warranty: "Attendance/support policy",
      unit: "month",
    },
    {
      id: "yoga-goal-consult",
      title: "Yoga Goal Consultation",
      icon: "🎯",
      group: "Consultation",
      description:
        "Consultation for fitness goals, wellness focus, and routine suitability.",
      basePrice: 249,
      priceType: "inspection",
      duration: "20-30 mins",
      warranty: "Consultation only",
      unit: "consult",
    },
  ],
};

export default yogaInstructorService;